export default {
  dayOfWeek: ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"],
  monthOfYear: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"]
};